import { createContext, useContext, useState, ReactNode, useEffect } from "react";

type Theme = "dark" | "light";
interface Ctx {
  theme: Theme;
  setTheme: (t: Theme) => void;
}
const HeaderThemeCtx = createContext<Ctx>({ theme: "dark", setTheme: () => {} });

export function HeaderThemeProvider({ children }: { children: ReactNode }) {
  const [theme, setTheme] = useState<Theme>("dark");
  return (
    <HeaderThemeCtx.Provider value={{ theme, setTheme }}>
      {children}
    </HeaderThemeCtx.Provider>
  );
}

export function useHeaderTheme() {
  return useContext(HeaderThemeCtx);
}

/** Set header theme for the page lifecycle. Resets to "dark" on unmount. */
export function useSetHeaderTheme(theme: Theme) {
  const { setTheme } = useHeaderTheme();
  useEffect(() => {
    setTheme(theme);
    return () => setTheme("dark");
  }, [theme, setTheme]);
}
